/* TrestleThorn — move sold-out products to the end of collection grids.
   Dawn/Search & Discovery only offer "out of stock last" as a search sort,
   not a collection sort, so this reorders card DOM after Dawn renders the
   grid (initial load) and after facets.js re-renders it via AJAX
   filtering/sorting.

   Small/medium collections (up to MAX_MERGE_PAGES of results) get a true
   cross-page sort: the other pages are fetched in the background (same
   sort/filter query string, just a different &page=), merged with the
   current page's items, sorted, and re-sliced so sold-out items are
   pushed to the very end of the whole result set — not just the bottom
   of whichever page they happened to land on. Larger collections (e.g.
   the several-thousand-product "all" collection) fall back to the
   simple per-page sort below, since fetching dozens of pages on every
   visit isn't worth the trade-off. */
(function () {
  var MAX_MERGE_PAGES = 6;

  function isSoldOut(item) {
    var badge = item.querySelector('.card__badge .badge');
    if (!badge) return false;
    return /sold\s*out/i.test(badge.textContent || '');
  }

  function gridItems(grid) {
    return Array.prototype.filter.call(grid.children, function (el) {
      return el.tagName === 'LI';
    });
  }

  function sortItems(items) {
    var inStock = [];
    var outOfStock = [];
    items.forEach(function (item) {
      (isSoldOut(item) ? outOfStock : inStock).push(item);
    });
    return inStock.concat(outOfStock);
  }

  function applyOrder(grid, sorted) {
    var current = gridItems(grid);
    var same =
      sorted.length === current.length &&
      sorted.every(function (el, i) {
        return el === current[i];
      });
    if (same) return;

    /* Remove every current item first — a cross-page merge can demote an
       item off this page entirely (replaced by one pulled in from another
       page), and appendChild alone would leave it behind as a stray. */
    current.forEach(function (el) {
      el.remove();
    });

    var frag = document.createDocumentFragment();
    sorted.forEach(function (el) {
      frag.appendChild(el);
    });
    grid.appendChild(frag);
  }

  function sortInPlace(grid) {
    applyOrder(grid, sortItems(gridItems(grid)));
  }

  function getPaginationInfo() {
    var items = document.querySelectorAll('.pagination__item');
    var current = 1;
    var total = 1;
    items.forEach(function (el) {
      var num = parseInt((el.textContent || '').trim(), 10);
      if (!isNaN(num)) {
        total = Math.max(total, num);
        if (el.classList.contains('pagination__item--current')) current = num;
      }
    });
    return { current: current, total: total };
  }

  function pageUrl(pageNum) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', pageNum);
    return url.toString();
  }

  function fetchPageItems(pageNum) {
    return fetch(pageUrl(pageNum))
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('#product-grid.product-grid');
        return grid ? gridItems(grid) : [];
      })
      .catch(function () {
        return [];
      });
  }

  function mergeAcrossPages(grid) {
    var info = getPaginationInfo();
    if (info.total <= 1 || info.total > MAX_MERGE_PAGES) return;

    var signature = info.total + '::' + window.location.search.replace(/([?&])page=\d+/, '$1').replace(/[?&]$/, '');
    if (grid.dataset.ttMergeSig === signature || grid.dataset.ttMerging === '1') return;
    grid.dataset.ttMerging = '1';

    var pageNums = [];
    for (var p = 1; p <= info.total; p++) {
      if (p !== info.current) pageNums.push(p);
    }

    Promise.all(pageNums.map(fetchPageItems)).then(function (results) {
      var ownItems = gridItems(grid);
      var perPage = ownItems.length;
      var allItems = ownItems.slice();
      results.forEach(function (items) {
        perPage = Math.max(perPage, items.length);
        allItems = allItems.concat(items);
      });

      var sorted = sortItems(allItems);
      var start = (info.current - 1) * perPage;
      var pageSlice = sorted.slice(start, start + perPage);

      grid.dataset.ttMergeSig = signature;
      delete grid.dataset.ttMerging;
      if (pageSlice.length) applyOrder(grid, pageSlice);
    });
  }

  function sortAllGrids() {
    document.querySelectorAll('#product-grid.product-grid').forEach(function (grid) {
      sortInPlace(grid);
      mergeAcrossPages(grid);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    sortAllGrids();

    /* facets.js replaces #ProductGridContainer's entire innerHTML on every
       sort/filter change, which destroys and recreates the #product-grid
       node itself. Observing that node directly leaves the observer
       watching a detached element after the first swap, so instead watch
       the stable container and re-locate the grid on every mutation. */
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    var observer = new MutationObserver(function () {
      sortAllGrids();
    });

    observer.observe(container, { childList: true, subtree: true });
  });
})();
